import { atom } from 'jotai';

/** 문의 유형. InquiryTypeBottomSheet 에서 선택한 값을 폼으로 전달한다. */
export const inquiryTypeIdAtom = atom<string>('');
